import React, { useCallback, useEffect, useState } from "react";
import Header from "commons/components/Header/Header";
import Confetti from "react-dom-confetti";
import { Button, Row, Select, Input, Col, message } from "antd";
import "./LuckyRaw.less";
import LuckyWinnerModal from "./LuckyWinnerModal";
import LuckyCustomerModal from "./LuckyCustomerModal";
import useGetCustomerWinner from "commons/hooks/useGetCustomerWinner";
import useGetListCustomerLuckyWheel from "commons/hooks/useGetListCustomerLuckyWheel";
import xoso from "../../assets/images/xoso.mp3";
import LuckyDigit from "./LuckyDigit";

const config = {
  angle: "180",
  spread: "240",
  startVelocity: 40,
  elementCount: 70,
  dragFriction: 0.12,
  duration: 3000,
  stagger: "10",
  width: "16px",
  height: "8px",
  perspective: "500px",
  colors: ["#a864fd", "#29cdff", "#78ff44", "#ff718d", "#fdff6a"],
};

const bookingCodeList = [
  "A0000",
  "B0000",
  "C0000",
  "D0000",
  "E0000",
  "F0000",
  "G0000",
  "H0000",
  "I0000",
  "J0000",
];
const projects = ["Dự án 1", "Dự án 2", "Dự án 3", "Dự án 4"];

export const LuckyRaw = () => {
  const [showTextAnimation] = useState(true);
  const [removeDrawnItem] = useState(false);
  const [results, setResults] = useState(["", "", "", "", ""]);
  const [showResult, setShowResult] = useState(true);
  const [active, setActive] = useState(false);
  const [disableDrawButton, setDisableDrawButton] = useState(false);
  const [isModalLuckyWinner, setIsModalLuckyWinner] = useState(false);
  const [isModalLuckyCustomer, setIsModalLuckyCustomer] = useState(false);
  const [items] = useState(bookingCodeList);
  const [currentItems, setCurrentItems] = useState(items);
  const [drawAgain, setDrawAgain] = useState(true);
  // eslint-disable-next-line no-unused-vars
  const [showMessageEndDraw, setShowMessageEndDraw] = useState(false);
  const [audio] = useState(new Audio(xoso));
  const { data: dataCustomerWinner, loadMoreData } = useGetCustomerWinner();
  const { data: dataCustomer, loadMoreDataCustomer } =
    useGetListCustomerLuckyWheel();

  const [selectedProject, setSelectedProject] = useState(projects[0]);
  const [cardQuantity, setCardQuantity] = useState(5);

  const Playit = useCallback(() => {
    audio.pause();
  }, [audio]);

  const PlayAudio = useCallback(() => {
    audio.currentTime = 0;
    audio.play().catch((err) => {
      console.warn("Autoplay blocked or error playing audio:", err);
    });
  }, [audio]);

  useEffect(() => {
    PlayAudio();
  }, [PlayAudio]);

  useEffect(() => {
    Playit();
  }, [Playit]);

  useEffect(() => {
    audio.addEventListener("ended", () => Playit());
    return () => {
      audio.removeEventListener("ended", () => Playit());
    };
  }, [Playit, audio]);

  const sleep = (time) => new Promise((resolve) => setTimeout(resolve, time));

  const randomDrawItem = async () => {
    setShowResult(false);
    setDisableDrawButton(true);
    setActive(true);

    try {
      await sleep(showTextAnimation ? 5000 : 0);

      // Tạo một bản sao của bookingCodeList để thao tác mà không làm thay đổi danh sách gốc
      const availableCodes = [...bookingCodeList];

      // Chọn số lượng thẻ ngẫu nhiên từ availableCodes, đảm bảo không trùng nhau
      const matrixResult = [];
      for (let i = 0; i < cardQuantity; i++) {
        const randomIndex = Math.floor(Math.random() * availableCodes.length);
        matrixResult.push(availableCodes[randomIndex]);

        // Loại bỏ giá trị đã chọn để không chọn lại
        availableCodes.splice(randomIndex, 1);
      }

      setResults(matrixResult);
      setShowResult(true);
      setDisableDrawButton(false);
      setDrawAgain(false);

      if (removeDrawnItem) {
        const randomIndex = Math.floor(Math.random() * currentItems.length);
        const copyCurrentItems = [...currentItems];
        copyCurrentItems.splice(randomIndex, 1);
        setCurrentItems(copyCurrentItems);
      }
    } catch (error) {
      alert("Error: " + error);
    }
  };

  const onDrawAgain = () => {
    setResults(Array.from({ length: cardQuantity }));
    setDrawAgain(true);
    setActive(false);
  };

  const onSentMail = () => {
    // alertMessage("Thống báo", `Gửi thống báo thành công ${results.map(item => `${item}, `)}`, false, false);
    message.success(
      `Gửi thống báo thành công ${results.map((item) => ` ${item}`)}`,
      1.5
    );
  };

  const renderLuckyBar = (array = [], data = {}) => {
    return (
      <Row align={"middle"} justify={"center"}>
        {array.map((value, idx) => (
          <LuckyDigit
            key={idx}
            showResult={data.showResult}
            value={value}
            active={data.active}
            items={items}
            delay={idx * 100}
          />
        ))}
      </Row>
    );
  };

  const handleSetCardQuantity = (value) => {
    setCardQuantity(value);
    setResults(Array.from({ length: value }));
    setDrawAgain(true);
    setActive(false);
  };

  return (
    <div className="container-fix">
      <div className="body-container">
        <Header />
        <div className="content-wrapper">
          <Row gutter={[16, 16]}>
            <Col>
              <Row>
                <label>Chọn Dự Án:</label>
              </Row>
              <Select
                value={selectedProject}
                onChange={setSelectedProject}
                className="content-field"
              >
                {projects.map((project, idx) => (
                  <Select.Option key={idx} value={project}>
                    {project}
                  </Select.Option>
                ))}
              </Select>
            </Col>
            <Col>
              <Row>
                <label>Số lượng thẻ:</label>
              </Row>
              <Input
                type="number"
                value={cardQuantity}
                onChange={(e) => handleSetCardQuantity(Number(e.target.value))}
                min={1}
                max={items.length}
                className="content-field"
              />
            </Col>
          </Row>
          <Row gutters={[16, 16]}>
            <div className="lucky-draw">
              <h1>Vòng quay may mắn</h1>
              <div className="lucky-draw__container">
                <div className="lucky-draw__block">
                  {renderLuckyBar(results, { showResult, active })}
                </div>
                <div className="lucky-draw__confetti">
                  <Confetti active={showResult} config={config} />
                </div>
              </div>
              {showMessageEndDraw && <p>Số lượt quay đã kết thúc!</p>}
              <div className="btn-action_draw">
                {drawAgain ? (
                  <Button
                    type="primary"
                    onClick={randomDrawItem}
                    disabled={disableDrawButton}
                    className="btn-draw"
                  >
                    {disableDrawButton ? "Đang quay..." : "Quay"}
                  </Button>
                ) : (
                  <Row gutter={[16, 16]}>
                    <Col>
                      <Button
                        type="primary"
                        onClick={onDrawAgain}
                        disabled={disableDrawButton}
                        className="btn-draw__again"
                      >
                        Quay lại
                      </Button>
                    </Col>
                    <Col>
                      <Button
                        type="primary"
                        onClick={onSentMail}
                        disabled={disableDrawButton}
                        className="btn-draw"
                      >
                        Gửi quyền chọn
                      </Button>
                    </Col>
                  </Row>
                )}
              </div>
            </div>

            <div className="footer-action">
              <Button
                onClick={async () => {
                  setIsModalLuckyCustomer(true);
                  await loadMoreDataCustomer();
                }}
                className="btn-submit"
              >
                Xem danh sách
              </Button>
              <Button
                onClick={async () => {
                  setIsModalLuckyWinner(true);
                  await loadMoreData();
                }}
                className="btn-submit"
              >
                Xem danh sách trúng thưởng
              </Button>
            </div>
          </Row>
        </div>
      </div>
      <LuckyWinnerModal
        visible={isModalLuckyWinner}
        onCancel={() => setIsModalLuckyWinner(false)}
        data={dataCustomerWinner}
      />
      <LuckyCustomerModal
        visible={isModalLuckyCustomer}
        onCancel={() => setIsModalLuckyCustomer(false)}
        data={dataCustomer}
      />
    </div>
  );
};
